export const elastic = 'easeOutElastic(1, 2)';
export const accelerating = 'easeInOutExpo'; // "cubicBezier(0.895, 0, 0.250, 0.920)"
